module.exports = __webpack_public_path__ + "files/b77be53d1e31f0313d2602ae72b63333.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-5.png
// module id = 502
// module chunks = 76